
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-44aa2ed8&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CategoryDetails.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CategoryDetails.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-44aa2ed8!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CategoryDetails.vue"),
  /* scopeId */
  "data-v-44aa2ed8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./dev/src/components/CategoryDetails.vue
// module id = ./dev/src/components/CategoryDetails.vue
// module chunks = 0